'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/react-autosuggest/dist/index.js
// module id = YWgm
// module chunks = 22